/* eslint-disable prettier/prettier */
/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================
*/

import MDBox from "admin/components/MDBox";
import MDTypography from "admin/components/MDTypography";
import MDBadge from "admin/components/MDBadge";
import Icon from "@mui/material/Icon";
import IconButton from "@mui/material/IconButton";

export default function data(events = [], onEdit, onDelete) {
    // Badge color mapping for Type of Violence
    const violenceColors = {
        "Repression": "error",
        "Insurgency": "warning",
        "Atrocities": "dark",
        "Terrorist Activity": "error",
        "Foreign Military Engagement": "info",
    };

    // Badge color mapping for Source
    const sourceColors = {
        "Manual Entry": "primary",
        "CSV Imported": "success",
        "AI (ChatGPT)": "info",
        "Data Crawling": "warning",
    };

    const Event = ({ name }) => (
        <MDBox display="flex" alignItems="center" lineHeight={1}>
            <MDBox lineHeight={1}>
                <MDTypography display="block" variant="button" fontWeight="regular">
                    {name}
                </MDTypography>
            </MDBox>
        </MDBox>
    );

    const Description = ({ text }) => (
        <MDBox lineHeight={1}>
            <MDTypography
                display="block"
                variant="caption"
                color="text"
                fontWeight="regular"
                sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    maxWidth: "200px",
                }}
            >
                {text || ""}
            </MDTypography>
        </MDBox>
    );

    return {
        columns: [
            { Header: "title", accessor: "conflictName", width: "22%", align: "left" },
            { Header: "country", accessor: "country", width: "8%", align: "left" },
            { Header: "type", accessor: "typeOfViolence", width: "12%", align: "center" },
            { Header: "description", accessor: "description", width: "25%", align: "left" },
            { Header: "source", accessor: "source", width: "10%", align: "center" },
            { Header: "date", accessor: "dateStart", width: "10%", align: "center" },
            { Header: "status", accessor: "status", width: "8%", align: "center" },
            { Header: "", accessor: "actions", width: "5%", align: "center" },
        ],

        rows: events.map((event) => ({
            conflictName: <Event name={event.conflictName || "N/A"} />,
            country: (
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    {event.country || "N/A"}
                </MDTypography>
            ),
            typeOfViolence: (
                <MDBadge
                    badgeContent={event.typeOfViolence || "Unknown"}
                    color={violenceColors[event.typeOfViolence] || "secondary"}
                    variant="gradient"
                    size="sm"
                />
            ),
            description: <Description text={event.description} />,
            source: (
                <MDBadge
                    badgeContent={event.typeOfSource === 'Data Crawling' ? 'Official statement' : (event.typeOfSource || 'Unknown')}
                    color={sourceColors[event.typeOfSource] || "secondary"}
                    variant="gradient"
                    size="sm"
                />
            ),
            dateStart: (
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    {event.dateStart ? new Date(event.dateStart).toLocaleDateString("en-GB", {day:"numeric",month:"short",year:"numeric"}) + " " + new Date(event.dateStart).toLocaleTimeString("en-GB", {hour:"2-digit",minute:"2-digit"}) : ""}
                </MDTypography>
            ),
            dateEnd: (
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    {event.dateEnd || ""}
                </MDTypography>
            ),
            sideA: (
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    {event.sideA || ""}
                </MDTypography>
            ),
            sideB: (
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    {event.sideB || ""}
                </MDTypography>
            ),
            deathA: (
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    {event.deathA || 0}
                </MDTypography>
            ),
            deathB: (
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    {event.deathB || 0}
                </MDTypography>
            ),
            deathCivilians: (
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    {event.deathCivilians || 0}
                </MDTypography>
            ),
            deathUnknown: (
                <MDTypography variant="caption" color="text" fontWeight="regular">
                    {event.deathUnknown || 0}
                </MDTypography>
            ),
            status: (
                <span style={{
                    display:'inline-block', width:'8px', height:'8px', borderRadius:'2px',
                    background: event.status === "Published" || event.status === "published" ? '#4CAF50' : '#555',
                }} title={event.status || "Unpublished"}></span>
            ),
            actions: (
                <MDBox display="flex" alignItems="center" justifyContent="center" gap={1}>
                    <IconButton
                        size="small"
                        color="info"
                        onClick={() => onEdit && onEdit(event)}
                    >
                        <Icon fontSize="small">edit</Icon>
                    </IconButton>
                    <IconButton
                        size="small"
                        color="error"
                        onClick={() => onDelete && onDelete(event._id)}
                    >
                        <Icon fontSize="small">delete</Icon>
                    </IconButton>
                </MDBox>
            ),
        })),
    };
}
